// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media Queries */
@media only screen and (min-width: 280px) and (max-width: 482px), only screen and (min-width: 482px) and (max-width: 599px), only screen and (min-width: 482px) and (max-width: 666px), only screen and (min-width: 667px) and (max-width: 1023px), only screen and (min-width: 1024px) and (max-width: 1280px) {
  .PlatformSectionOne {
    padding: 100px 30px 30px;
  }
  .PlatformSectionOne .PlatformSectionOne-header {
    padding-top: 0;
    text-align: center;
  }
  .PlatformSectionOne .PlatformSectionOne-header .PlatformSectionOne-header-1 {
    font-size: 18px;
  }
  .PlatformSectionOne .PlatformSectionOne-header .PlatformSectionOne-header-2 {
    font-size: 20px;
    margin-top: 10px;
  }
  .PlatformSectionOne .PlatformSectionOne-header .PlatformSectionOne-sub-header {
    font-size: 16px;
    line-height: 1.8;
    margin-top: 5px;
    margin-bottom: 20px;
  }
  .PlatformSectionOne .PlatformSectionOne-card {
    display: block;
    margin-top: 10px;
  }
  .PlatformSectionOne .PlatformSectionOne-card .box-card {
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    margin-right: 0px;
    width: auto;
    height: auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .PlatformSectionOne .PlatformSectionOne-card .box-card .card-description {
    margin-top: 0px;
    font-size: 14px;
    font-weight: 400;
    margin-left: 20px;
  }
  .PlatformSectionOne .PlatformSectionOne-content {
    margin-top: 45px;
    flex-direction: column;
  }
  .PlatformSectionOne .PlatformSectionOne-content .para-top {
    font-size: 18px;
    padding: 0;
  }
  .PlatformSectionOne .PlatformSectionOne-content .para {
    font-size: 16px;
    padding: 5px 10px;
  }
  .PlatformSectionOne .PlatformSectionOne-content .image {
    width: 110%;
    padding: 10px;
    margin-bottom: 20px;
  }
  .PlatformSectionOne .PlatformSectionOne-content .left-content,
  .PlatformSectionOne .PlatformSectionOne-content .right-content {
    width: 100%;
  }
  .PlatformSectionOne .PlatformSectionOne-content .left-content {
    padding-left: 0px;
    height: auto;
  }
  .PlatformSectionOne .PlatformSectionOne-content .right-content {
    margin-top: 30px;
    padding: 0px;
  }
  .PlatformSectionOne .PlatformSectionOne-content .right-content .card-content {
    padding: 20px;
    height: auto;
  }
  .PlatformSectionOne .PlatformSectionOne-content .right-content .card-content .header {
    font-size: 20px;
    line-height: 1.3;
  }
  .PlatformSectionOne .PlatformSectionOne-content .right-content .card-content .description {
    width: 100%;
  }
  .PlatformSectionFour-Discover {
    flex-direction: column;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology {
    padding: 30px !important;
    width: 100% !important;
    height: auto !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality .subHeading,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology .subHeading {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality .heading,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology .heading {
    font-size: 20px !important;
    line-height: 1.3 !important;
    margin: 20px 0 !important;
    font-weight: 400 !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality .discover-link,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology .discover-link {
    margin-top: 10px !important;
  }
}
@media only screen and (min-width: 667px) and (max-width: 900px), only screen and (min-width: 667px) and (max-width: 1023px), only screen and (min-width: 1024px) and (max-width: 1280px) {
  .PlatformSectionOne .PlatformSectionOne-header .PlatformSectionOne-sub-header {
    font-size: 16px !important;
  }
  .PlatformSectionOne .PlatformSectionOne-content .para {
    font-size: 18px !important;
    padding: 5px 30px !important;
  }
  .PlatformSectionOne .PlatformSectionOne-card {
    display: flex !important;
    align-items: center;
    flex-direction: row !important;
    justify-content: center;
    margin-top: 10px;
    text-align: center;
    padding: 0px;
    gap: 20px !important;
    flex-wrap: wrap;
  }
  .PlatformSectionOne .PlatformSectionOne-card .box-card {
    width: 30% !important;
    margin-right: inherit;
    height: 230px;
    margin-top: 30px;
  }
  .PlatformSectionOne .PlatformSectionOne-card .box-card .card-description {
    margin-top: 5px !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality .subHeading,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology .subHeading {
    font-size: 18px !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality .heading,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology .heading {
    font-size: 26px !important;
    line-height: 1.3 !important;
    margin: 20px 0 !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality .discover-link,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology .discover-link {
    margin-top: 10px !important;
  }
}
@media only screen and (min-width: 667px) and (max-width: 1023px), only screen and (min-width: 1024px) and (max-width: 1280px) {
  .PlatformSectionFour-Discover {
    flex-direction: row !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology {
    min-height: 270px !important;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1280px) {
  .PlatformSectionOne {
    padding: 140px 60px 60px !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology {
    padding: 40px !important;
  }
}
@media only screen and (min-width: 1281px) and (max-width: 1482px), only screen and (min-width: 1024px) and (max-width: 1280px) {
  .PlatformSectionOne .PlatformSectionOne-card {
    display: flex !important;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
  }
  .PlatformSectionOne .PlatformSectionOne-card .box-card {
    width: 30% !important;
    padding: 20px !important;
  }
  .ContactUsSectionOne {
    padding: 25vh 100px !important;
  }
  .ContactUsSectionOne .ContactUsSectionOne-right {
    padding-left: 60px !important;
  }
}
@media only screen and (min-width: 667px) and (max-width: 776px) {
  .PlatformSectionOne .PlatformSectionOne-card {
    display: flex !important;
    align-items: center;
    flex-direction: row !important;
    justify-content: center;
    margin-top: 10px;
    text-align: center;
    padding: 0px;
    gap: 20px !important;
    flex-wrap: wrap;
  }
  .PlatformSectionOne .PlatformSectionOne-card .box-card {
    width: 40% !important;
    margin-right: inherit;
    height: 230px;
    margin-top: 30px;
  }
  .PlatformSectionOne .PlatformSectionOne-card .box-card .card-description {
    margin-top: 5px !important;
  }
  .PlatformSectionFour-Discover {
    flex-direction: column !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology {
    min-height: unset !important;
  }
}
@media only screen and (min-width: 1281px) and (max-width: 1482px) {
  .PlatformSectionOne {
    padding-left: 120px;
    padding-right: 120px;
  }
  .PlatformSectionOne-content .image {
    width: 100% !important;
  }
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-functionality,
  .PlatformSectionFour-Discover .PlatformSectionFour-discover-technology {
    padding: 30px !important;
    width: 100% !important;
    height: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/media-queries.scss","webpack://./src/components/Platform/platform.scss"],"names":[],"mappings":"AAEA,kBAAA;AAmCI;ECjCH;IACC,wBAAA;EADA;EAEA;IACC,cAAA;IACA,kBAAA;EAAD;EACC;IACC,eAAA;EACF;EACC;IACC,eAAA;IACA,gBAAA;EACF;EACC;IACC,eAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EACF;EAEA;IACC,cAAA;IACA,gBAAA;EAAD;EACC;IACC,aAAA;IACA,mBAAA;IACG,aAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;EACL;EAAK;IACC,eAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;EAEN;EAGA;IACC,gBAAA;IACA,sBAAA;EADD;EAEC;IACC,eAAA;IACA,UAAA;EAAF;EAEC;IACC,eAAA;IACA,iBAAA;EAAF;EAEC;IACC,WAAA;IACA,aAAA;IACA,mBAAA;EAAF;EAEC;;IAEI,WAAA;EAAL;EAEI;IACC,iBAAA;IACA,YAAA;EAAL;EAEI;IACC,gBAAA;IACA,YAAA;EAAL;EACK;IACC,aAAA;IACG,YAAA;EACT;EAAM;IACC,eAAA;IACA,gBAAA;EAEP;EAAM;IACC,WAAA;EAEP;EAKD;IACC,sBAAA;EAHA;EAIA;;IAEC,wBAAA;IACG,sBAAA;IACA,uBAAA;EAFJ;EAGC;;IACC,0BAAA;IACA,2BAAA;EAAF;EAEC;;IACC,0BAAA;IACG,2BAAA;IACA,yBAAA;IACA,2BAAA;EACL;EACC;;IACC,2BAAA;EAEF;AACF;ADvEI;EC6ED;IACC,0BAAA;EAHF;EAUC;IACC,0BAAA;IACA,4BAAA;EARF;EAYA;IACI,wBAAA;IACA,mBAAA;IACA,8BAAA;IACA,uBAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;IACA,oBAAA;IACA,eAAA;EAVJ;EAWI;IACC,qBAAA;IACA,qBAAA;IACA,aAAA;IACA,gBAAA;EATL;EAUK;IACC,0BAAA;EARN;EAiBC;;IACC,0BAAA;EAdF;EAgBC;;IACC,0BAAA;IACG,2BAAA;IACA,yBAAA;EAbL;EAeC;;IACC,2BAAA;EAZF;AACF;ADlHI;ECoIH;IACC,8BAAA;EAfA;EAgBA;;IAEC,4BAAA;EAdD;AACF;AD3HI;EC8IH;IACC,mCAAA;EAhBA;EAmBA;;IAEC,wBAAA;EAjBD;AACF;ADpII;EC0JF;IACC,wBAAA;IACA,mBAAA;IACA,eAAA;IACA,SAAA;EAnBD;EAoBC;IACC,qBAAA;IACA,wBAAA;EAlBF;EAyBD;IACC,8BAAA;EAvBA;EAwBA;IACC,6BAAA;EAtBD;AACF;AAyBA;EAEE;IACI,wBAAA;IACA,mBAAA;IACA,8BAAA;IACA,uBAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;IACA,oBAAA;IACA,eAAA;EAxBJ;EAyBI;IACC,qBAAA;IACA,qBAAA;IACA,aAAA;IACA,gBAAA;EAvBL;EAwBK;IACC,0BAAA;EAtBN;EA2BD;IACC,iCAAA;EAzBA;EA0BA;;IAEC,4BAAA;EAxBD;AACF;ADnLI;ECgNH;IACC,mBAAA;IACA,oBAAA;EA1BA;EA4BD;IACC,sBAAA;EA1BA;EA8BA;;IAEC,wBAAA;IACG,sBAAA;IACA,uBAAA;EA5BJ;AACF","sourcesContent":["$size__site_content_width : 1024px;\n\n/* Media Queries */ \n\n$media_queries : (\n    'mobile360'         : unquote(\"only screen and (min-width: 280px) and (max-width: 400px)\"),\n    'xs'                : unquote(\"only screen and (min-width: 280px) and (max-width: 482px)\"),\n    'miniMobile'        : unquote(\"only screen and (min-width: 280px) and (max-width: 450px)\"),\n    'mediumMobile'      : unquote(\"only screen and (min-width: 450px) and (max-width: 482px)\"),\n    'eReaders'          : unquote(\"only screen and (min-width: 482px) and (max-width: 599px)\"),\n    'mobile'            : unquote(\"only screen and (min-width: 482px) and (max-width: 666px)\"),\n    'customMobile'      : unquote(\"only screen and (min-width: 600px) and (max-width: 900px)\"),\n    'miniTab'           : unquote(\"only screen and (min-width: 667px) and (max-width: 900px)\"),\n    'tablet'            : unquote(\"only screen and (min-width: 667px) and (max-width: 1023px)\"),\n    'customTablet'      : unquote(\"only screen and (min-width: 900px) and (max-width: 1023px)\"),\n    'wideTablet'        : unquote(\"only screen and (min-width: 1024px) and (max-width: 1280px)\"),\n    'miniDesktop'       : unquote(\"only screen and (min-width: 1281px) and (max-width: 1482px)\"),\n    'desktop'           : unquote(\"only screen and (min-width: 1025px)\"),\n    'wideScreens'       : unquote(\"only screen and (min-width: 1339px)\"),\n    'hdScreen'          : unquote(\"only screen and (min-width: 1800px)\"),\n    'retina2'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)\"),\n    'retina3'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 288dpi)\"),\n    'landscape'         : unquote(\"screen and (orientation:landscape)\"),    \n    'portrait'          : unquote(\"screen and (orientation:portrait)\")\n);\n\n@mixin devices($breakpoints) {\n    $conditions : ();\n    @each $breakpoint in $breakpoints {\n        // If the key exists in the map\n        $conditions: append(\n            $conditions,\n            #{inspect(map-get($media_queries, $breakpoint))},\n            comma\n        );\n    }\n\n    @media #{$conditions} {\n        @content;\n    }\n\n}\n","@import '../../media-queries.scss';\n\n// Responsive\n@include devices(xs eReaders mobile tablet wideTablet) {\n\t.PlatformSectionOne {\n\t\tpadding: 100px 30px 30px;\n\t\t.PlatformSectionOne-header {\n\t\t\tpadding-top: 0;\n\t\t\ttext-align: center;\n\t\t\t.PlatformSectionOne-header-1 {\n\t\t\t\tfont-size: 18px;\n\t\t\t}\n\t\t\t.PlatformSectionOne-header-2 {\n\t\t\t\tfont-size: 20px;\n\t\t\t\tmargin-top: 10px;\n\t\t\t}\n\t\t\t.PlatformSectionOne-sub-header {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 1.8;\n\t\t\t\tmargin-top: 5px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t}\n\t\t.PlatformSectionOne-card{\n\t\t\tdisplay: block;\n\t\t\tmargin-top: 10px;\n\t\t\t.box-card{\n\t\t\t\tpadding: 20px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t    display: flex;\n\t\t\t    margin-right: 0px;\n\t\t\t    width: auto;\n\t\t\t    height: auto;\n\t\t\t    flex-direction: row;\n\t\t\t    justify-content: center;\n    \t\t\talign-items: center;\n    \t\t\t.card-description{\n    \t\t\t\tmargin-top: 0px;\n    \t\t\t\tfont-size: 14px;\n    \t\t\t\tfont-weight: 400;\n    \t\t\t\tmargin-left: 20px;\n    \t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.PlatformSectionOne-content {\n\t\t\tmargin-top: 45px;\n\t\t\tflex-direction: column;\n\t\t\t.para-top{\n\t\t\t\tfont-size: 18px;\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t\t.para {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tpadding: 5px 10px;\n\t\t\t}\n\t\t\t.image {\n\t\t\t\twidth: 110%;\n\t\t\t\tpadding: 10px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t\t.left-content,\n\t\t    .right-content{\n\t\t    \twidth: 100%;\n\t\t    }\n\t\t    .left-content{\n\t\t    \tpadding-left: 0px;\n\t\t    \theight: auto;\n\t\t    }\n\t\t    .right-content{\n\t\t    \tmargin-top: 30px;\n\t\t    \tpadding: 0px;\n\t\t    \t.card-content{\n\t\t    \t\tpadding: 20px;\n        \t\t\theight: auto;\n\t\t    \t\t.header{\n\t\t    \t\t\tfont-size: 20px;\n\t\t    \t\t\tline-height: 1.3;\n\t\t    \t\t}\n\t\t    \t\t.description{\n\t\t    \t\t\twidth: 100%;\n\t\t    \t\t}\n\t\t    \t}\n\t\t    }\n\t\t}\n\t}\n\n\t.PlatformSectionFour-Discover {\n\t\tflex-direction: column;\n\t\t.PlatformSectionFour-discover-functionality,\n\t\t.PlatformSectionFour-discover-technology {\n\t\t\tpadding: 30px !important;\n\t\t    width: 100% !important;\n\t\t    height: auto !important;\n\t\t\t.subHeading {\n\t\t\t\tfont-size: 14px !important;\n\t\t\t\tfont-weight: 600 !important;\n\t\t\t}\n\t\t\t.heading {\n\t\t\t\tfont-size: 20px !important;\n\t\t\t    line-height: 1.3 !important;\n\t\t\t    margin: 20px 0 !important;\n\t\t\t    font-weight: 400 !important;\n\t\t\t}\n\t\t\t.discover-link {\n\t\t\t\tmargin-top: 10px !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include devices(miniTab tablet wideTablet) {\n\t.PlatformSectionOne {\n\t\t.PlatformSectionOne-header {\n\t\t\t.PlatformSectionOne-sub-header {\n\t\t\t\tfont-size: 16px !important;\n\t\t\t}\n\t\t}\n\n\n\n\t\t.PlatformSectionOne-content {\n\t\t\t.para {\n\t\t\t\tfont-size: 18px !important;\n\t\t\t\tpadding: 5px 30px !important;\n\t\t\t}\n\t\t}\n\n\t\t.PlatformSectionOne-card {\n\t\t    display: flex !important;\n\t\t    align-items: center;\n\t\t    flex-direction: row !important;;\n\t\t    justify-content: center;\n\t\t    margin-top: 10px;\n\t\t    text-align: center;\n\t\t    padding: 0px;\n\t\t    gap: 20px !important;\n\t\t    flex-wrap: wrap;\n\t\t    .box-card {\n\t\t    \twidth: 30% !important;\n\t\t    \tmargin-right: inherit;\n\t\t    \theight: 230px;\n\t\t    \tmargin-top: 30px;\n\t\t    \t.card-description{\n\t\t    \t\tmargin-top: 5px !important;\n\t\t    \t}\n\t\t    }\n\t\t}\n\t}\n\n\t.PlatformSectionFour-Discover {\n\t\t.PlatformSectionFour-discover-functionality,\n\t\t.PlatformSectionFour-discover-technology {\n\t\t\t.subHeading {\n\t\t\t\tfont-size: 18px !important;\n\t\t\t}\n\t\t\t.heading {\n\t\t\t\tfont-size: 26px !important;\n\t\t\t    line-height: 1.3 !important;\n\t\t\t    margin: 20px 0 !important;\n\t\t\t}\n\t\t\t.discover-link {\n\t\t\t\tmargin-top: 10px !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include devices(tablet wideTablet) {\n\t.PlatformSectionFour-Discover {\n\t\tflex-direction: row !important;\n\t\t.PlatformSectionFour-discover-functionality,\n\t\t.PlatformSectionFour-discover-technology {\n\t\t\tmin-height: 270px !important;\n\t\t}\n\t}\n}\n\n@include devices(wideTablet) {\n\t.PlatformSectionOne {\n\t\tpadding: 140px 60px 60px !important;\n\t}\n\t.PlatformSectionFour-Discover {\n\t\t.PlatformSectionFour-discover-functionality,\n\t\t.PlatformSectionFour-discover-technology {\n\t\t\tpadding: 40px !important;\n\t\t}\n\t}\n}\n@include devices(miniDesktop wideTablet) {\n\t.PlatformSectionOne {\n\t\t.PlatformSectionOne-card {\n\t\t\tdisplay: flex !important;\n\t\t\tflex-direction: row;\n\t\t\tflex-wrap: wrap;\n\t\t\tgap: 20px;\n\t\t\t.box-card {\n\t\t\t\twidth: 30% !important;\n\t\t\t\tpadding: 20px !important;\n\t\t\t\t.card-description {\n\t\t\t\t \n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.ContactUsSectionOne {\n\t\tpadding: 25vh 100px !important;\n\t\t.ContactUsSectionOne-right {\n\t\t\tpadding-left: 60px !important;\n\t\t}\n\t}\n}\n@media only screen and (min-width: 667px) and (max-width: 776px) {\n\t.PlatformSectionOne {\n\t\t.PlatformSectionOne-card {\n\t\t    display: flex !important;\n\t\t    align-items: center;\n\t\t    flex-direction: row !important;;\n\t\t    justify-content: center;\n\t\t    margin-top: 10px;\n\t\t    text-align: center;\n\t\t    padding: 0px;\n\t\t    gap: 20px !important;\n\t\t    flex-wrap: wrap;\n\t\t    .box-card {\n\t\t    \twidth: 40% !important;\n\t\t    \tmargin-right: inherit;\n\t\t    \theight: 230px;\n\t\t    \tmargin-top: 30px;\n\t\t    \t.card-description{\n\t\t    \t\tmargin-top: 5px !important;\n\t\t    \t}\n\t\t    }\n\t\t}\n\t}\n\t.PlatformSectionFour-Discover {\n\t\tflex-direction: column !important;\n\t\t.PlatformSectionFour-discover-functionality,\n\t\t.PlatformSectionFour-discover-technology {\n\t\t\tmin-height: unset !important;\n\t\t}\n\t}\n}\n\n@include devices(miniDesktop) {\n\t.PlatformSectionOne {\n\t\tpadding-left: 120px;\n\t\tpadding-right: 120px;\n\t}\n\t.PlatformSectionOne-content .image {\n\t\twidth: 100% !important;\n\t}\n\n\t.PlatformSectionFour-Discover {\n\t\t.PlatformSectionFour-discover-functionality,\n\t\t.PlatformSectionFour-discover-technology {\n\t\t\tpadding: 30px !important;\n\t\t    width: 100% !important;\n\t\t    height: auto !important;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
